import * as ROUTES from 'constant/routes'
import * as COLOR from 'constant/color'
import { Redirect, Route, Switch, withRouter, useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getAllCategories } from 'action/category'
import { getHelp } from 'action/help'
import { addUrlChange } from 'action/metrics'
import { updateLocationPreference, updateTC } from 'action/user'
import { Layout, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import NAV_ROUTES from 'constant/nav-routes'
import Sidebar from 'view/component/sidebar'
import Footer from 'view/component/footer'
import PropTypes from 'prop-types'
import CookieModal from 'view/component/cookie-modal'
import LegalPolicy from 'view/component/legal-policy'
import * as USER_TYPES from 'constant/user-types'
import * as Components from './lazy-components'

const { Content } = Layout

const determineUserNavRoutes = (user) => NAV_ROUTES.filter(({ onlyAdmin, permissions }) => permissions.includes(user.user_type.name) || (user.is_site_admin_user_type && !onlyAdmin && permissions.includes(USER_TYPES.ADMIN)))

/* eslint-disable max-lines-per-function */
const LoggedInRoutes = ({ getAllCategories, user, getHelp, addUrlChange, updateLocationPreference, updateTC, showFooter }) => {
  const history = useHistory()
  const [showModal, setModal] = useState(false)
  const [showTCModal, setTCModal] = useState(false)
  const [showCookieModal, setCookieModal] = useState(false)
  const userNavRoutes = determineUserNavRoutes(user)

  useEffect(() => {
    getAllCategories()
    getHelp()
  }, [])

  useEffect(() => {
    if (user.accepted_tc === null) {
      setTCModal(true)
    }
    return history.listen((location) => {
      if (user.location_tracking) {
        addUrlChange(true, location.pathname)
      } else if (user.location_tracking === null) {
        setModal(true, location.pathname)
      } else {
        addUrlChange(false, location.pathname)
      }
    })
  }, [history, user])

  const handleOk = () => {
    setModal(false)
    updateLocationPreference(true, user.uuid)
    addUrlChange(true, history.location.pathname)
  }

  const handleCancel = () => {
    setModal(false)
    setCookieModal(true)
  }

  const handleTCOk = () => {
    updateTC(true)
    setTCModal(false)
  }

  const handleTCCancel = () => {
    setTCModal(false)
  }

  const handleCookiesOk = (location) => {
    setCookieModal(false)

    updateLocationPreference(!location, user.uuid)
    addUrlChange(true, history.location.pathname)
  }

  const handleCookiesCancel = () => {
    setCookieModal(false)
    addUrlChange(false, history.location.pathname)
  }
  return (
    <>
      <Sidebar />
      {showFooter && <Footer />}
      {getLayout(userNavRoutes, user)}
      {getModal(handleCancel, handleOk, showModal)}
      {getTCModal(handleTCCancel, handleTCOk, showTCModal)}
      <CookieModal
        handleCancel={handleCookiesCancel}
        handleOk={handleCookiesOk}
        showCookieModal={showCookieModal}
      />
    </>
  )
}
const getModal = (handleCancel, handleOk, showModal) => (
  <Modal
    bodyStyle={{
      backgroundColor: COLOR.GREY
    }}
    cancelText={'Cookie Settings'}
    okText={'Accept All Cookies'}
    onCancel={handleCancel}
    onOk={handleOk}
    title='Premier League'
    visible={showModal}
    width={700}
  >
    <p>The Premier League website uses essential cookies to make our website work. We would also like to use analytics cookies to improve your user experience. Non-essential cookies will be set only if you accept. For more detailed information about cookies we use, see our
      <a
        className='text-pink'
        href='https://www.premierleague.com/cookie-policy'
        rel='noreferrer'
        target='_blank'
      >
        <span> Cookie Policy.</span>
      </a>
    </p><br />
    <p>Essential cookies are required for the operation of our website. You may disable these using the user settings but this may affect website functionality.</p><br />
    <p>Non-essential cookies help us improve the functionality of our website by collecting information and reporting on your use of the website as well as improving your user experience. You can manage your non-essential cookies using the Cookie Settings.</p>
  </Modal>
)

const getTCModal = (handleCancel, handleOk, showModal) => (
  <Modal
    bodyStyle={{
      backgroundColor: COLOR.GREY
    }}
    cancelButtonProps={{ style: { display: 'none' } }}
    okText={'Accept Terms and Conditions'}
    onOk={handleOk}
    title='Premier League'
    visible={showModal}
    width={700}
  >
    <LegalPolicy />
  </Modal>
)
const getLayout = (userNavRoutes, user) => (
  <Layout>
    <Content>
      <Switch>
        {userNavRoutes.map(({ component, exact, href }, index) => (
          <Route
            component={Components[component]}
            exact={exact}
            key={index}
            path={href}
          />
        ))}
        <Route
          exact
          path='/'
          render={() => {
            return user.default_site
          ? <Redirect to={`/site/${user.default_site}`} />
          : <Redirect to={ROUTES.DEFAULT[user.user_type.name]} />
          }
          }
        />

      </Switch>
    </Content>
  </Layout>)

LoggedInRoutes.propTypes = {
  addUrlChange: PropTypes.func,
  getAllCategories: PropTypes.func,
  getHelp: PropTypes.func,
  updateLocationPreference: PropTypes.func,
  updateTC: PropTypes.func,
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  showFooter: state.site.showFooter,
  user: state.auth.user
})

const mapDispatchToProps = (dispatch) => ({
  addUrlChange: bindActionCreators(addUrlChange, dispatch),
  getAllCategories: bindActionCreators(getAllCategories, dispatch),
  getHelp: bindActionCreators(getHelp, dispatch),
  updateLocationPreference: bindActionCreators(updateLocationPreference, dispatch),
  updateTC: bindActionCreators(updateTC, dispatch)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoggedInRoutes)
)
